/**
 * documentation at
 * https://webartelier.de/fee_doc/list_functions.html#getcsscustomproperty
 */
var feeJS = feeJS || {};
feeJS.getCssCustomProperty = (scope, name) => {
  const styles = getComputedStyle(scope);
  return styles.getPropertyValue(name).trim();
}